<template>
  <div id="app">
    <v-app>
      <v-container fluid grid-list-lg text-xs-center class>
        <v-layout row wrap>
          <v-flex xs12 lg6 md6 sm6
            ><v-tabs
              centered
              :icons-and-text="
                $vuetify.breakpoint.name != 'lg' && $vuetify.breakpoint.name != 'sm' && $vuetify.breakpoint.name != 'md'
              "
              color="#dd356e"
              dark
            >
              <v-tabs-slider color="yellow"></v-tabs-slider>

              <v-tab href="#tab-1" @click="clearUrl">
                Gallery
                <v-icon>image</v-icon>
              </v-tab>

              <v-tab href="#tab-2" @click="clearUrl">
                Upload
                <v-icon>upload</v-icon>
              </v-tab>

              <v-tab href="#tab-3" @click="clearUrl">
                Paste URL
                <v-icon>link</v-icon>
              </v-tab>

              <v-tab-item :key="1" value="tab-1">
                <v-card>
                  <div id="overlay" v-if="loading"></div>

                  <v-container grid-list-sm fluid>
                    <v-layout row wrap
                      ><v-flex v-for="(item, index) in dataImages" :key="index" xs4>
                        <v-hover>
                          <v-card
                            flat
                            :width="width + 'px'"
                            :height="height + 'px'"
                            slot-scope="{ hover }"
                            :class="`elevation-${hover ? 10 : 0}`"
                          >
                            <img
                              :width="width"
                              :height="height"
                              style="object-fit: cover"
                              :id="item.id"
                              :src="item.src"
                              class="galleryImg"
                              :class="item.id == selectedItemId ? 'selected' : ''"
                              @click="onSelectImage(item, $event)"
                            />
                          </v-card>
                        </v-hover>
                      </v-flex>
                    </v-layout>
                  </v-container>
                </v-card>
              </v-tab-item>
              <v-tab-item :key="2" value="tab-2">
                <v-card flat>
                  <div v-if="!file">
                    <div
                      :class="['dropZone', dragging ? 'dropZone-over' : '']"
                      @dragenter="dragging = true"
                      @dragleave="dragging = false"
                    >
                      <div class="dropZone-info" @drag="onChange">
                        <span class="fa fa-cloud-upload dropZone-title"></span>
                        <v-icon>upload</v-icon>
                        <span class="dropZone-title">Drop file or click to upload</span>
                        <div class="dropZone-upload-limit-info">
                          <div>maximum file size: 5 MB</div>
                        </div>
                      </div>
                      <input type="file" @change="onChange" />
                    </div>
                  </div>
                  <div v-else class="dropZone-uploaded">
                    <div class="dropZone-uploaded-info">
                      <span class="dropZone-title">Uploaded {{ file.name }}</span>

                      <v-btn text link flat class="removeFile" @click="removeFile"> Upload another </v-btn>
                    </div>
                  </div>
                </v-card>
              </v-tab-item>

              <v-tab-item :key="3" value="tab-3">
                <v-card>
                  <v-container grid-list-sm fluid>
                    <v-layout row wrap
                      ><v-flex xs12>
                        <v-text-field
                          v-model="pastedUrlText"
                          @paste="onPaste"
                          outline
                          label="Paste image URL here"
                          clearable
                        ></v-text-field>
                      </v-flex>
                    </v-layout>
                  </v-container>
                </v-card>
              </v-tab-item> </v-tabs
          ></v-flex>
          <v-flex xs12 lg6 md6 sm6>
            <v-toolbar color="#dd356e" dark>
              <v-toolbar-title>Analysis Result</v-toolbar-title> <v-icon>poll</v-icon>
              <v-spacer></v-spacer>
            </v-toolbar>
            <v-card id="analysisResult" class="d-flex align-center justify-center mb-6">
              <v-container bg fill-height grid-list-md text-xs-center>
                <v-layout row wrap align-center>
                  <v-flex xs12 v-if="hasError && !loading">
                    <v-alert value="true" color="red" outline type="error">
                      <b>Problem retrieving the url</b> <br />Try uploading the image instead. If it doesn't work,
                      please try another image.</v-alert
                    >
                  </v-flex>

                  <v-flex xs12 v-if="(selectedSrc == null || selectedSrc == '') && !hasError">
                    <div class="title">Please select or upload an image or paste url</div>
                  </v-flex>
                  <v-flex xs12 v-show="selectedSrc != null && selectedSrc != '' && !hasError">
                    <v-avatar v-show="selectedSrc != null && selectedSrc != ''" size="200" color="grey lighten-4">
                      <img style="object-fit: cover" id="selectedImg" :src="selectedSrc"
                    /></v-avatar>
                    <div v-if="!loading">
                      <br />

                      <div v-if="!hasError && !loading">
                        <div class="tree-container">
                          <tree
                            :leafTextMargin="
                              $vuetify.breakpoint.name == 'xs' || $vuetify.breakpoint.name == 'sm' ? 2 : 25
                            "
                            :data="tree"
                            :class="foundnode ? 'found-node' : ''"
                            :layoutType="
                              $vuetify.breakpoint.name == 'xs' || $vuetify.breakpoint.name == 'sm'
                                ? 'vertical'
                                : 'horizontal'
                            "
                            class="tree"
                          >
                            <template #node="{ data, node: { depth } }">
                              <template v-if="data.children && data.children.length > 0">
                                <circle r="2"> </circle>
                              </template>
                              <template v-else>
                                <circle
                                  :fill="data.level"
                                  :stroke="data.boundaryColor"
                                  r="20"
                                  :style="{
                                    opacity: data.opacity + ' !important',

                                    fill: data.level + ' !important',
                                  }"
                                >
                                  <title x="15">{{ data.text }} {{ depth }}</title>
                                </circle>
                              </template>
                            </template></tree
                          >
                        </div>
                      </div>
                    </div>
                    <div v-else><br /><v-progress-circular indeterminate color="primary"></v-progress-circular></div>
                  </v-flex>
                </v-layout>
              </v-container>
            </v-card>
          </v-flex>
        </v-layout>
        <v-layout row wrap></v-layout>
      </v-container>
      <v-footer height="auto" color="#dd356e ">
        <v-layout justify-center row wrap>
          <v-flex lighten-2 py-3 text-xs-center white--text xs12>
            For more information on how we process data, please refer to
            <a href="https://www.privately.eu/legal" target="_blank">our privacy policy </a>
          </v-flex>
          <v-flex lighten-2 py-3 text-xs-center white--text xs12>
            &copy; Copyright 2022 Privately - All Rights Reserved
          </v-flex>
        </v-layout>
      </v-footer>
    </v-app>
  </div>
</template>




<script>
import axios from "axios";
import { tree } from "vued3tree";

axios.defaults.headers.common["Access-Control-Allow-Origin"] = "*";
axios.defaults.withCredentials = false;

export default {
  components: { tree },
  methods: {
    opacity(value) {
      return value == this.predictedClass ? 1 : 0.1;
    },
    color(value, total) {
      if (total === undefined) {
        total = 2;
      }
      if (value < 20 / total) {
        return this.smallColor;
      } else {
        return this.bigColor;
      }
    },
    async onPaste(evt) {
      this.hasError = false;
      try {
        this.pastedUrl = evt.clipboardData.getData("text/plain");
        if (this.checkImageURL(this.pastedUrl)) {
          let imgElm = document.getElementById("selectedImg");
          this.selectedSrc = this.pastedUrl;
          imgElm.style.display = "block";
          await this.loadImage(this.pastedUrl, imgElm);

          if (imgElm.complete) {
            this.estimateRisk(null, this.pastedUrl, false);
            this.hasError = false;
          }
        } else {
          this.selectedSrc = "";
          this.hasError = true;
          return;
        }
      } catch (err) {
        this.loading = false;
        this.hasError = true;
      }
    },
    clearUrl() {
      this.hasError = false;
      this.pastedUrl = "";
      this.pastedUrlText = "";
    },
    onSelectImage: function (data, event) {
      if (this.loading) {
        event.stopPropagation();
        return;
      }
      this.selectedItemId = data.id;
      this.file = "";
      this.imageSelected = data;
      this.selectedSrc = data.src || "";

      this.estimateRisk(null, data.src, true);
    },

    async loadImage(url, elem) {
      return new Promise((resolve, reject) => {
        elem.onload = () => resolve(elem);
        elem.crossOrigin = "Anonymous";
        elem.onerror = reject;
        elem.src = url;
      });
    },

    onChange(e) {
      var files = e.target.files || e.dataTransfer.files;

      if (!files.length) {
        this.dragging = false;
        return;
      }
      this.createFile(files[0]);
    },
    async getBase64(file) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => resolve(reader.result);
        reader.onerror = (error) => reject(error);
      });
    },
    async estimateRisk(file, url, isGallerySrc) {
      this.loading = true;
      let params = {
        url: isGallerySrc ? "https://showroom.privately.swiss" + url : url,
      };
      let base64File = "";
      if (url == null) {
        base64File = await this.getBase64(file).catch((err) => {
          console.log(err);
        });
      }
      let payload = JSON.stringify({ image_data: base64File });
      return axios
        .post("https://showroom.privately.swiss:8081/showroom/nudity4c", url == null ? payload : params, {
          headers: {
            "Content-Type": "application/json; charset=utf-8",
          },
        })
        .then((response) => {
          this.loading = false;
          if (response.data) {
            console.log(response.data);
            this.predictedClass = response.data.predicted_class;
            this.tree = {
              name: "",
              parent: "null",
              value: 1,
              children: [
                {
                  name: "Safe",
                  parent: "Top Level",
                  value: 1.0,
                  level: this.bigColor,
                  opacity: this.opacity("plain"),
                },
                {
                  name: "Not Safe",
                  parent: "Top Level",
                  value: 1.0,
                  level: this.bigColor,
                  children: [
                    {
                      name: "sexy selfie",
                      parent: "Not Safe",
                      value: 1,
                      level: this.bigColor,
                      opacity: this.opacity("sexy_selfie"),
                    },
                    {
                      name: "porn",
                      parent: "Not Safe",
                      value: 1,
                      level: this.bigColor,
                      opacity: this.opacity("porn"),
                    },
                    {
                      name: "bikini",
                      parent: "Not Safe",
                      value: 1,
                      level: this.bigColor,
                      opacity: this.opacity("bikini"),
                    },
                  ],
                },
              ],
            };
          }
        })
        .catch((error) => {
          this.loading = false;
          console.error("There was an error !", error);
        });
    },
    getBase64Image(img) {
      var canvas = document.createElement("canvas");
      canvas.width = img.naturalWidth;
      canvas.height = img.naturalHeight;

      var ctx = canvas.getContext("2d");
      ctx.drawImage(img, 0, 0);
      var dataURL = canvas.toDataURL("image/png");
      return dataURL.replace(/^data:image\/(png|jpg);base64,/, "");
    },

    createFile(file) {
      if (!file.type.match("image.*")) {
        alert("please select image file");
        this.dragging = false;
        return;
      }

      if (file.size > 5000000) {
        alert("please check file size no over 5 MB.");
        this.dragging = false;
        return;
      }

      this.file = file;
      this.estimateRisk(this.file, null, null);

      this.selectedSrc = URL.createObjectURL(this.file);
      this.dragging = false;
    },
    removeFile() {
      this.file = "";
    },
    checkImageURL(url) {
      return url.match(/^https?:\/\/.+\/.+$/);
    },
    async getBase64(file) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => resolve(reader.result);
        reader.onerror = (error) => reject(error);
      });
    },
  },
  computed: {
    extension() {
      return this.file ? this.file.name.split(".").pop() : "";
    },
  },
  computed: {
    height() {
      switch (this.$vuetify.breakpoint.name) {
        case "xs":
          return 88;
        case "sm":
          return 88;
        case "md":
          return 88;
        case "lg":
          return 140;
        case "xl":
          return 200;
      }
    },
    width() {
      switch (this.$vuetify.breakpoint.name) {
        case "xs":
          return 88;
        case "sm":
          return 88;
        case "md":
          return 88;
        case "lg":
          return 140;
        case "xl":
          return 200;
      }
    },
  },
  data: () => ({
    tree: {},
    foundnode: false,
    childDetected: null,
    predictedClass: null,
    spoofDetected: false,
    selectedItemId: "",
    dataImages: [
      {
        id: "1",
        src: require("@/assets/images/gallery-nudity/img_1.jpeg"),
        alt: "Alt Image 1",
      },
      {
        id: "2",
        src: require("@/assets/images/gallery-nudity/img_2.jpeg"),
        alt: "Alt Image 2",
      },
      {
        id: "3",
        src: require("@/assets/images/gallery-nudity/img_3.jpeg"),
        alt: "Alt Image 2",
      },
      {
        id: "4",
        src: require("@/assets/images/gallery-nudity/img_4.jpeg"),
        alt: "Alt Image 1",
      },
      {
        id: "5",
        src: require("@/assets/images/gallery-nudity/img_5.jpeg"),
        alt: "Alt Image 2",
      },
      {
        id: "6",
        src: require("@/assets/images/gallery-nudity/img_6.jpeg"),
        alt: "Alt Img",
      },
      {
        id: "7",
        src: require("@/assets/images/gallery-nudity/img_7.jpeg"),
        alt: "Alt imggg",
      },
      {
        id: "8",
        src: require("@/assets/images/gallery-nudity/img_8.jpeg"),
        alt: "Alt imggg",
      },
      {
        id: "9",
        src: require("@/assets/images/gallery-nudity/img_9.jpeg"),
        alt: "Alt imggg",
      },
    ],
    file: "",
    pastedUrl: "",
    noFaceDetected: false,
    ageNotReliablyDetected: false,
    pastedUrlText: "",
    base64img: "",
    loading: false,
    imageSelected: "",
    isRisky: null,
    hasError: false,
    bigColor: "#2196F3",
    smallColor: "orange",
    containsChild: "",
    selectedSrc: null,
    dragging: false,
  }),
};
</script>

<style>
.tree-container {
  height: 500px;
}

#overlay {
  position: absolute;
  display: grid;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.3);
  z-index: 2;
  cursor: pointer;
}

.treeclass .nodetree text {
  font-size: 15px !important;
}

/* For extremely small screen devices (595px and below) */
@media only screen and (max-width: 595px) {
  .treeclass .nodetree text {
    font-size: 13px !important;
  }
}

.treeclass .linktree {
  fill: none;
  stroke: #555;
  stroke-opacity: 0.15;
}

.dropZone {
  width: 100%;
  height: 200px;
  position: relative;
  border: 2px dashed #eee;
}

.dropZone:hover {
  border: 2px solid #2e94c4;
}

.dropZone:hover .dropZone-title {
  color: #1975a0;
}

.dropZone-info {
  color: #a8a8a8;
  position: absolute;
  top: 50%;
  width: 100%;
  transform: translate(0, -50%);
  text-align: center;
}

.dropZone-title {
  color: #787878;
}

.dropZone input {
  position: absolute;
  cursor: pointer;
  top: 0px;
  right: 0;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 100%;
  opacity: 0;
}

.dropZone-upload-limit-info {
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
}

.dropZone-over {
  background: #5c5c5c;
  opacity: 0.8;
}

.dropZone-uploaded {
  width: 100%;
  height: 200px;
  position: relative;
  border: 2px dashed #eee;
}

.dropZone-uploaded-info {
  display: flex;
  flex-direction: column;
  align-items: center;
  color: #a8a8a8;
  position: absolute;
  top: 50%;
  width: 100%;
  transform: translate(0, -50%);
  text-align: center;
}

@media only screen and (hover: none) and (pointer: coarse) {
  .galleryImg img {
    width: 33px !important;
    height: 33px !important;
  }

  #selectedImg {
    width: 200px;
    height: 200px;
  }
}

.removeFile {
  width: 200px;
}

.selected {
  border: 5px solid rgb(221, 53, 110) !important;
}
</style>